import { z } from "zod";

export const ModuleSettingsSchema = z.object({
  structureAreasOrgChartModuleEnabled: z.boolean(),
  cardAndListModuleEnabled: z.boolean(),
  structureEmployeesOrgChartModuleEnabled: z.boolean(),
});
